import { render, staticRenderFns } from "./input-file.vue?vue&type=template&id=2e8eb524&"
import script from "./input-file.vue?vue&type=script&lang=js&"
export * from "./input-file.vue?vue&type=script&lang=js&"
import style0 from "./input-file.vue?vue&type=style&index=0&id=2e8eb524&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports